import request from '@/config/request'
import {getJsonStore,getStore} from '@/config/mUtils'
import { MessageBox, Message } from 'element-ui'
/**
 * 登陆
 */


//export const getAuthCode = data => fetch('/deepcamp/api/user/authCode', data);


export const getAuthCode = data => {
    //console.log(data);

   return request({
        url: '/deepcamp/api/user/authCode?mobile='+data.mobile,
        method: 'get'
    })
}

export const login = data =>{
    return request({
        url:'/deepcamp/api/user/login',
        method:'POST',
        data:data,
        // transformRequest: [function (data) {
        //     let ret = ''
        //     for (let it in data) {
        //         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        //     }
        //     return ret
        // }],
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export const getUserInfo = () =>{
    if(getJsonStore('userinfo')===null||getStore('token')===null){
        return null;
    }
    return request({
        url:'/deepcamp/api/person/info?userId='+getJsonStore('userinfo')['userId'],
        method:'GET',
        headers: {
            'accessToken': getStore('token')
        }
       
    })
}

export const getLoginStatus = () =>{
    if (getJsonStore('userinfo')===null||getStore('token')===null){
        return false;
    }
    return true;
}

export const addUserInfo = data =>{
    return request({
        url:'/deepcamp/api/person/info',
        method:'put',
        data:data,
        headers: {
            'accessToken': getStore('token'),
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json, text/plain, application/pdf'
        }
       
    })
}
export const getUserInfos = data =>{
    let dataStr = ''; //数据拼接字符串
    Object.keys(data).forEach(key => {
        dataStr += key + '=' + data[key] + '&';
    })
    if(dataStr !== ""){
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
        if(data.type!==undefined){
            return request({
                url:'/deepcamp/api/person/infos?'+dataStr,
                method:'get',
                headers: {
                    'accessToken': getStore('token'),
                },
                responseType: 'blob'
            })

        }else{
            return request({
                url:'/deepcamp/api/person/infos?'+dataStr,
                method:'get',
                headers: {
                    'accessToken': getStore('token'),
                }

            })
        }

    }else{
        Message({
            message: '参数不可为空',
            type: 'error',
            duration: 5 * 1000
        })
    }

}
export const getResume = data =>{
    return request({
        url:'deepcamp/api/person/resume?userId='+data,
        method:'GET',
        headers: {
            'accessToken': getStore('token')
        },
        responseType: 'blob'
       
    })
}
export const getActivitys = data =>{
    let dataStr = ''; //数据拼接字符串
    Object.keys(data).forEach(key => {
        dataStr += key + '=' + data[key] + '&';
    })
    if(dataStr !== ""){
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
        return request({
            url:'/deepcamp/api/activity?'+dataStr,
            method:'GET',
            headers: {
               // 'accessToken': getStore('token')
            }
        })
    }else{
        Message({
            message: '参数不可为空',
            type: 'error',
            duration: 5 * 1000
        })
    }
}
export const addActivitys = data =>{
    return request({
        url:'/deepcamp/api/activity',
        method:'POST',
        data:data,
        headers: {
            'accessToken': getStore('token'),
        }
       
    })
}
export const updateActivitys = data =>{
    return request({
        url:'/deepcamp/api/activity',
        method:'PUT',
        data:data,
        headers: {
            'accessToken': getStore('token'),
        }
       
    })
}

export const addRegistration = data =>{
    return request({
        url:'/deepcamp/api/activity/registration',
        method:'POST',
        data:data,
        headers: {
            'accessToken': getStore('token'),
        }
    })
}
export const editStatusRegistration = data =>{
    return request({
        url:'/deepcamp/api/activity/registration',
        method:'PUT',
        data:data,
        headers: {
            'accessToken': getStore('token'),
        }
    })
}
export const getRegistration = data =>{
    let dataStr = ''; //数据拼接字符串
    Object.keys(data).forEach(key => {
        dataStr += key + '=' + data[key] + '&';
    })
    if(dataStr !== ""){
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
        if(data.type==="query"){
            return request({
                url:'/deepcamp/api/activity/registration?'+dataStr,
                method:'GET',
                headers: {
                    'accessToken': getStore('token')
                },
            })
        }else if(data.type==="csv"){
            return request({
                url:'/deepcamp/api/activity/registration?'+dataStr,
                method:'GET',
                headers: {
                    'accessToken': getStore('token')
                },
                responseType: 'blob'
            })
        }

    }else{
        Message({
            message: '参数不可为空',
            type: 'error',
            duration: 5 * 1000
        })
    }
}

export const addAchievement = data =>{
    return request({
        url:'/deepcamp/api/achievement',
        method:'POST',
        data:data,
        headers: {
            'accessToken': getStore('token'),
        }
    })
}

export const updateAchievement = data =>{
    return request({
        url:'/deepcamp/api/achievement',
        method:'PUT',
        data:data,
        headers: {
            'accessToken': getStore('token'),
        }
    })
}

export const getAchievement = data =>{
    let dataStr = ''; //数据拼接字符串
    Object.keys(data).forEach(key => {
        dataStr += key + '=' + data[key] + '&';
    });
    if(dataStr !== ""){
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
        return request({
            url:'/deepcamp/api/achievement?'+dataStr,
            method:'GET',
        })
    }else{
        Message({
            message: '参数不可为空',
            type: 'error',
            duration: 5 * 1000
        })
    }
};

export const uploadFile = data =>{
    return request({
        url:'/deepcamp/api/file',
        method:'POST',
        data:data,
        headers: {
            'accessToken': getStore('token'),
            'Content-Type': 'multipart/form-data',
        }

    })
}

export const addCourse = data =>{
    return request({
        url:'/deepcamp/api/course',
        method:'POST',
        data:data,
        headers: {
            'accessToken': getStore('token'),
        }
    })
}

export const updateCourse = data =>{
    return request({
        url:'/deepcamp/api/course',
        method:'PUT',
        data:data,
        headers: {
            'accessToken': getStore('token'),
        }
    })
}

export const getCourse = data =>{
    let dataStr = ''; //数据拼接字符串
    Object.keys(data).forEach(key => {
        dataStr += key + '=' + data[key] + '&';
    });
    if(dataStr !== ""){
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
        return request({
            url:'/deepcamp/api/course?'+dataStr,
            method:'GET',
        })
    }else{
        Message({
            message: '参数不可为空',
            type: 'error',
            duration: 5 * 1000
        })
    }
};

export const getUrl = data =>{

    return request({
        url:data,
        method:'GET',
    })

};


// WEBPACK FOOTER //
// ./src/api/getData.js